import { render, staticRenderFns } from "./pwdLogin.vue?vue&type=template&id=20f4efe0&scoped=true&"
import script from "./pwdLogin.vue?vue&type=script&lang=js&"
export * from "./pwdLogin.vue?vue&type=script&lang=js&"
import style0 from "./pwdLogin.vue?vue&type=style&index=0&lang=less&module=true&"
import style1 from "./pwdLogin.vue?vue&type=style&index=1&id=20f4efe0&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "20f4efe0",
  null
  
)

component.options.__file = "pwdLogin.vue"
export default component.exports